import React, { Fragment, useEffect, useState } from "react";
import WithNavigationToHome from "../components/WithNavigationToHome";
import { LayoutGrid, LayoutGridCell } from "@cdk-uip/react-layout-grid";
import "./style.css";
import {
  Card,
  Chip,
  IconCheckCircle,
  IconRadioButtonUnchecked,
  Input,
  INPUT_ICON_POSITIONS,
  INPUT_SIZES,
  IconSearch,
  PrimaryButton,
} from "cdk-radial";
import BundleListV2 from "./viewv2";
import { CREATE_BUNDLES } from "./screen";
import { FILTER_OPTIONS } from "../Utils/constants";

function ViewBundles(props) {
  const {
  auth,
  setReservedBundles,
  setBundleShareName,
  setBundleShareId,
  setScreen,
  setSelectedBundle,
  ApiBundleManagementReducer,
  getBundleList,
} = props;

const { bundleList, unAuthorizedUser, fetchingBundleList } = ApiBundleManagementReducer;
  const { accessToken } = auth;
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [filteredBundleList, setFilteredBundleList] = useState([]);
  const handleCreateBundle = () => {
    setScreen(CREATE_BUNDLES);
  };

  const handleSearchQueryChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    setReservedBundles(bundleList.map((bundle) => bundle.name));
  }, [bundleList]);

  useEffect(() => {
    if (accessToken !== null) {
      getBundleList({ accessToken });
    }
  }, [accessToken]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
    let nextList = Array.isArray(bundleList) ? bundleList : [];

    const normalizedStatusFilter = String(statusFilter || "all").toLowerCase();
    if (
      normalizedStatusFilter === "active" ||
      normalizedStatusFilter === "inactive"
    ) {
      nextList = nextList.filter(
        (bundle) =>
          String(bundle?.status || "").toLowerCase() ===
          normalizedStatusFilter,
      );
    }

    const query = String(searchQuery || "")
      .trim()
      .toLowerCase();
    if (query) {
      nextList = nextList.filter((bundle) => {
        const name = String(bundle?.name || "").toLowerCase();
        const id = String(bundle?.id || "").toLowerCase();
        return name.includes(query) || id.includes(query);
      });
    }

    setFilteredBundleList(nextList);
     }, 500);
      return () => clearTimeout(timeOutId);
  }, [bundleList, searchQuery, statusFilter]);

  return (
    <Fragment>
      <LayoutGrid
        className={
          "s-content-route--subscription-management c-layout-section__dash-grid"
        }
      >
        <LayoutGridCell
          className={"c-layout-section__dash-grid-cell"}
          span={12}
          spanTablet={8}
          spanPhone={4}
        >
          {!unAuthorizedUser && (
            <Card className="bundle-management-header-card">
              <div className="bundle-management-header-top">
                <div>
                  <div className="bundle-management-title">API Bundle Management</div>
                  <div className="bundle-management-subtitle">
                    Create, configure, and manage API bundles across different organization types
                  </div>
                </div>
                <PrimaryButton
                  text="Create New Bundle"
                  size={INPUT_SIZES.LARGE}
                  onClick={handleCreateBundle}
                />
              </div>

              <div className="bundle-management-header-bottom">
                <div className="bundle-management-filter">
                  <div className="bundle-management-filter-label">Filter By</div>
                  <div className="bundle-management-filter-chips">
                    {FILTER_OPTIONS.map((opt) => (
                      <Chip
                        key={opt.value}
                        icon={
                          statusFilter === opt.value ? (
                            <IconCheckCircle />
                          ) : (
                            <IconRadioButtonUnchecked />
                          )
                        }
                        isSelected={statusFilter === opt.value}
                        hasCheckbox={true}
                        label={opt.label}
                        value={opt.value}
                        onClick={() => setStatusFilter(opt.value)}
                      />
                    ))}
                  </div>
                </div>

                <div className="bundle-management-search">
                  <Input
                    type="text"
                    value={searchQuery}
                    iconPosition={INPUT_ICON_POSITIONS.LEADING}
                    icon={<IconSearch />}
                    placeholder="Search by bundle name, bundle id...."
                    size={INPUT_SIZES.SMALL}
                    onChange={handleSearchQueryChange}
                  />
                </div>
              </div>
            </Card>
          )}
          <BundleListV2
            bundleList={bundleList}
            getBundleList={getBundleList}
            fetchingBundleList={fetchingBundleList}
            accessToken={accessToken}
            filteredBundleList={filteredBundleList}
            setBundleShareId={setBundleShareId}
            setBundleShareName={setBundleShareName}
            setScreen={setScreen}
            setSelectedBundle={setSelectedBundle}
          />
        </LayoutGridCell>
      </LayoutGrid>
    </Fragment>
  );
}

ViewBundles = WithNavigationToHome(ViewBundles);
export default ViewBundles;
